import BaseStore from '@/store/BaseStore'
import { Action, Module, Mutation } from 'vuex-module-decorators'
import { Job, jobApi } from '@/api'

export interface ModalJobListStoreInterface {
  sample?: string
}

@Module({
  name: 'ModalJobListStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalJobListStore extends BaseStore {
  _jobIds: number[] = []

  _jobs: Job[] = []

  get jobs(): Job[] {
    return this._jobs
  }

  @Mutation
  public clear(): void {
    this._jobIds = []
    this._jobs = []
  }

  @Mutation
  public addJobId(id: number) {
    this._jobIds.unshift(id)
  }

  @Mutation
  public setJobs(jobs: Job[]) {
    this._jobs = jobs
  }

  @Action({ rawError: true })
  public async fetch() {
    const jobs = await jobApi.getAllByIds(this._jobIds)
    this.setJobs(jobs)
  }

  @Action({ rawError: true })
  public async newJobId(id: number) {
    this.addJobId(id)
    await this.fetch()
  }
}
